import { defineComponent as t, openBlock as o, createBlock as r, unref as p, mergeProps as v, withCtx as i, createElementVNode as l } from "vue";
import { RevIcon as m } from "@ds/components/Icon";
const c = /* @__PURE__ */ t({
  name: "IconSimUnavailable",
  __name: "IconSimUnavailable",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(a) {
    const n = a;
    return (d, e) => (o(), r(p(m), v(n, { "view-box": "0 0 24 24" }), {
      default: i(() => [...e[0] || (e[0] = [
        l("path", { d: "M11 5.25A.75.75 0 0 1 11.75 6v2a.75.75 0 0 1-1.5 0V6A.75.75 0 0 1 11 5.25m3 0A.75.75 0 0 1 14.75 6v2a.75.75 0 0 1-1.5 0V6A.75.75 0 0 1 14 5.25" }, null, -1),
        l("path", {
          "fill-rule": "evenodd",
          d: "M2.47 2.47a.75.75 0 0 1 1.06 0l.98.98a2.25 2.25 0 0 1 1.99-1.2h8.293a1.25 1.25 0 0 1 .884.366l3.707 3.707a1.25 1.25 0 0 1 .366.884v11.482l1.78 1.78a.75.75 0 0 1-1.06 1.061l-18-18a.75.75 0 0 1 0-1.06M6.5 3.75A.75.75 0 0 0 5.75 4.5v.19l1.5 1.5V6a.75.75 0 0 1 1.5 0v1.69l4.56 4.56h2.19a1.25 1.25 0 0 1 1.25 1.25v2.19l1.5 1.5V7.31l-3.56-3.56H6.5m8.75 10.44v-.44h-.44l.44.44",
          "clip-rule": "evenodd"
        }, null, -1),
        l("path", { d: "M5.75 8.91V19.5a.75.75 0 0 0 .75.75h10.59l1.28 1.28.032.03a2.2 2.2 0 0 1-.902.19h-11a2.25 2.25 0 0 1-2.25-2.25V7.41l1.5 1.5" }, null, -1),
        l("path", { d: "M10.59 13.75H8.75v3.5h5.34l1.495 1.495Q15.543 18.75 15.5 18.75h-7a1.25 1.25 0 0 1-1.25-1.25v-4a1.25 1.25 0 0 1 1.25-1.25h.59l1.5 1.5" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  c as default
};
